import {
    getConstributorsBreakdown,
    getSkillsBreakdown,
    mock,
    updateUserStatus as apiUpdateUserStatus
} from '../apiCaller';
import { UserStatus } from 'src/enums/user';
import {
    CONTRIBUTORS_BREAKDOWN,
    SKILLS_BREAKDOWN
} from 'src/constants/community';

export const fetchSkillsBreakdown = () => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(mock ? SKILLS_BREAKDOWN : getSkillsBreakdown());
        }, 300);
    });
};

export const fetchConstributorsBreakdown = () => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(
                mock ? CONTRIBUTORS_BREAKDOWN : getConstributorsBreakdown()
            );
        }, 300);
    });
};

export const updateUserStatus = (userId: string, status: UserStatus) => {
    return apiUpdateUserStatus(userId, status);
};
